import classes from '@/components/Shares/Button.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { AspectRatio, Box, Button, Group, Image, Text, rem, useMatches } from '@mantine/core';
export const BlogBanner: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const line = useMatches({
    base: 1,
    sm: 3
  });
  return <Box pos="relative">
      <AspectRatio ratio={1320 / 343}>
        <Group pos="absolute" inset={0} align="center" pl={{
        base: 10,
        sm: 20,
        md: 48
      }} py={{
        base: 10,
        sm: 12,
        md: 16
      }}>
          <Box>
            <Text fz={{
            base: 10,
            sm: 12
          }} fw={700} c="var(--text-prime)">
              {i18n._('BLOG')}
            </Text>

            <Text fz={{
            base: 14,
            md: 18,
            lg: 40
          }} mt={{
            base: 4,
            md: 10
          }} lh={{
            base: rem(14),
            sm: rem(18),
            lg: rem(40)
          }} className={gunterzBold.className} c="var(--text-white)">
              {i18n._('Lorem ipsum dolor sit')}
            </Text>

            <Text w={{
            base: 200,
            sm: 350,
            lg: 480
          }} fz={{
            base: 10,
            md: 12,
            lg: 14
          }} lineClamp={line} c="var(--text-dark)" fw={500}>
              {i18n._('Lorem ipsum dolor sit amet consectetur. Tristique feugiat at aliquet egestas integer augue. Consectetur dictum enim in magna fringilla ornare orci dolor.')}
            </Text>

            <Button h={{
            base: 24,
            sm: 36,
            lg: 46
          }} maw={115} mt={{
            base: 4,
            md: 10,
            lg: 20
          }} fz={{
            base: 10,
            sm: 12
          }} classNames={classes}>
              {i18n._('Read more')}
            </Button>
          </Box>
        </Group>

        <Image src="/assets/blog/blog-banner.png" alt="blogs-banner" />
      </AspectRatio>
    </Box>;
};